import {
  initialState,
  Actions,
  State,
  SELECTED_PLAN,
  SELECTED_PLAN_SUCCESS,
  SELECTED_PLAN_ERROR,
  RESET_SELECTED_PLAN
} from "../../types/plan/selected-plan";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SELECTED_PLAN:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case SELECTED_PLAN_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case SELECTED_PLAN_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_SELECTED_PLAN:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
